import React, { useContext } from 'react'
import {
  Row,
  Container,
  CenteredSpinner,
  Card,
  Badge,
  Col,
  Button
} from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
import { Layout } from '../../layout/Layout'
import { AuthContext } from '../../context/Auth'
import { Paths } from '../../routes/paths'
import { Header } from './Header'
import { AccountInformation } from './AccountInformation/AccountInformation'
import { Groups } from './Groups/Groups'

import { ReactComponent as BenefitBuilderPreview } from '../../assets/benefitBuilderPreview.svg'

export const Home = () => {
  const history = useHistory()
  const { userData, authLoading } = useContext(AuthContext)

  if (!userData && !authLoading) {
    history.push(Paths.login)
  }

  return (
    <Layout showUserDropdown>
      {authLoading ? (
        <CenteredSpinner />
      ) : (
        <>
          <Header name={userData?.first_name || ''} />
          <Container
            fluid
            style={{ paddingBottom: 100, paddingRight: 100, paddingLeft: 50 }}
          >
            <Row
              className="my-3"
            >
              <Col style={{ flexGrow: 2 }}>
                <Card className="pl-3">
                  <Card.Body>
                    <Row>
                      <Col>
                        <Row>
                          <div className="d-flex align-items-center">
                            <Badge
                              style={{
                                backgroundColor: '#0099AE',
                                color: 'white'
                              }}
                            >
                              NEW
                            </Badge>
                            <span
                              style={{
                                fontWeight: 600,
                                fontSize: 20,
                                marginLeft: 10,
                                color: '#343A40'
                              }}
                            >
                              Benefit Builder{' '}
                              <span
                                style={{
                                  textDecoration: 'underline',
                                  fontStyle: 'italic'
                                }}
                              >
                                Beta
                              </span>{' '}
                              is now available!
                            </span>
                          </div>
                        </Row>
                        <Row>
                          <span
                            style={{
                              color: '#6C757D',
                              fontWeight: 500,
                              fontSize: 18
                            }}
                          >
                            Navigate to Benefit Builder in your navigation to
                            start creating and viewing Angle quotes.
                          </span>
                        </Row>
                        <Row>
                          <Button
                            className="mt-3"
                            onClick={() => history.push(Paths.quotes)}
                          >
                            Try it now!
                          </Button>
                        </Row>
                      </Col>
                      <Col xs="auto">
                        <BenefitBuilderPreview className="h-100" />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <AccountInformation user={userData} />
              </Col>
            </Row>
            <Row noGutters style={{ borderRadius: '6px', border: '1px solid #efefef' }}>
              <Groups />
            </Row>
          </Container>
        </>
      )}
    </Layout>
  )
}
